import { useEffect } from "react";

/**
 * useDocumentTitle, updates the browser tab title (and optionally the meta
 * description) for the duration of a route. Restores the original title on
 * unmount so going Back/Forward doesn't leak stale titles.
 *
 *   useDocumentTitle("Catalogue · Heritage Dahlias", "Every heirloom dahlia in our catalogue.");
 */
export default function useDocumentTitle(title, description) {
  useEffect(() => {
    if (!title) return undefined;
    const prevTitle = document.title;
    document.title = title;
    let metaEl;
    let prevDesc;
    if (description) {
      metaEl = document.querySelector('meta[name="description"]');
      if (metaEl) {
        prevDesc = metaEl.getAttribute("content");
        metaEl.setAttribute("content", description);
      }
    }
    return () => {
      document.title = prevTitle;
      if (metaEl && prevDesc != null) {
        metaEl.setAttribute("content", prevDesc);
      }
    };
  }, [title, description]);
}
